import type { UUID } from '@shared/api';

/**
 * Backend now returns ready-to-use media objects. Two shapes by `publicUrl`:
 *  - true  → permanent CDN URL (logo, video, eco certs, product photos)
 *  - false → presigned URL with 15-min TTL (KYC certs, RFQ attachments, quote / order docs, chat)
 *
 * `url === null` means the object is missing or not yet uploaded → render placeholder.
 */
export interface MediaLink {
  id: UUID;
  url: string | null;
  contentType: string | null;
  publicUrl: boolean;
}

export function isImageMedia(link: MediaLink | null | undefined): boolean {
  return !!link?.contentType?.startsWith('image/');
}

export function isVideoMedia(link: MediaLink | null | undefined): boolean {
  return !!link?.contentType?.startsWith('video/');
}
